// Dias da semana de treino.
//
// Step NOVO no fluxo (o Objetivo.dc.html tem a pergunta "dias" e o formulário
// antigo não). Grava `TRAINING_DAYS` no blob de respostas — o
// `saveUserObjective` guarda o objeto inteiro, então não há contrato novo.
//
// É este campo que alimenta `frequencia_dias` / `frequencia_qtd` do
// `generateCompletePlan` ao fim do onboarding: antes essa informação só
// existia se a pessoa passasse depois pelo gerador de plano.

import React, { useEffect, useState } from "react";

import { Dias } from "../widgets/Widgets.jsx";

const StepDiasTreino = ({ setCanProceed, setStepData, setNeedsButton }) => {
  const [dias, setDias] = useState([]);

  // Múltipla escolha: o auto-advance não pode disparar no primeiro dia.
  useEffect(() => {
    setNeedsButton?.(true);
    return () => setNeedsButton?.(false);
  }, [setNeedsButton]);

  useEffect(() => {
    const valido = dias.length > 0;
    setCanProceed(valido);
    setStepData(valido ? { TRAINING_DAYS: dias } : null);
  }, [dias, setCanProceed, setStepData]);

  const alternar = (d) =>
    setDias((atual) => (atual.includes(d) ? atual.filter((x) => x !== d) : [...atual, d]));

  return <Dias valores={dias} onToggle={alternar} />;
};

export default StepDiasTreino;
